import { AddressLookupSelectedAddress } from "@eventr/common";
import { StateCreator } from "zustand";
import { EphemeralStore } from "./useEphemeralStore";

/**
 * A value picked on a pushed native screen, waiting to be applied to a form field.
 * endName/endValue are set only for a start/end pair picked together (a date range).
 */
export interface FormFieldPickerResult {
  name: string;
  value: string | undefined;
  endName?: string;
  endValue?: string;
  /** Set by the pick-up address picker when the address should also become the organisation's. */
  applyToOrganisation?: boolean;
}

interface FormFieldPickerState {
  formFieldPickerResult: FormFieldPickerResult | null;
  /** The address a pushed address picker screen opens on. */
  addressPickerSeed: AddressLookupSelectedAddress | undefined;
}

interface FormFieldPickerActions {
  setFormFieldPickerResult: (result: FormFieldPickerResult) => void;
  clearFormFieldPickerResult: () => void;
  setAddressPickerSeed: (address: AddressLookupSelectedAddress | undefined) => void;
}

export interface FormFieldPickerSlice extends FormFieldPickerState, FormFieldPickerActions {}

export const createFormFieldPickerSlice: StateCreator<EphemeralStore, [], [], FormFieldPickerSlice> = (set) => ({
  formFieldPickerResult: null,
  setFormFieldPickerResult: (result) => set({ formFieldPickerResult: result }),
  clearFormFieldPickerResult: () => set({ formFieldPickerResult: null }),
  addressPickerSeed: undefined,
  setAddressPickerSeed: (address) => set({ addressPickerSeed: address }),
});
